import React from "react";
import {Button} from "reactstrap";
import { Link } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/App.css';


export const RoundButtonPrimary = (props) => {
    return (
        <Link to={props.to}>
            <Button className='button-primary'>
                {props.text}
            </Button>
        </Link>
    );
};



export const RoundButtonSecondary = (props) => {
    return (
        (props.href) ? (
            <a href={props.href} target="_blank" rel="noopener noreferrer">
                <Button className='button-secondary'>
                    {props.text}
                </Button>
            </a>
        ) : (
            <Link to={props.to}>
                <Button className='button-secondary'>
                    {props.text}
                </Button>
            </Link>
        )   
    );
};
